import type { ReactNode } from 'react'
import { TOKENS } from './dashboard-primitives'

/**
 * The editorial title a panel or a panel-level note opens on.
 *
 * The Journey's until Spec 2 D5 (#169), when the house error note, which also
 * opens on it, moved out to `components/errors/`. One definition, so a section
 * that could not load is titled at the same scale as the chapters around it.
 */
export function PanelTitle({ children }: { children: ReactNode }) {
  return (
    <h3
      className="mt-2.5 leading-tight"
      style={{
        fontFamily: 'var(--font-display)',
        fontWeight: 500,
        fontSize: 'clamp(1.25rem, 2.2vw, 1.75rem)',
        letterSpacing: '-0.018em',
        color: TOKENS.cream,
      }}
    >
      {children}
    </h3>
  )
}
